import invoice from './views/index.vue';

export default [
  {
    path: '/invoice/:id',
    name: 'user-invoice',
    meta: {
      requiredAuth: true
    },
    component: invoice,
  }
];